const report = window.fedreport ? new window.fedreport() : null;
export default (err, vm, info) => {
	if (report) {
		report.log({
			type: 'error',
			message: 'vue error' + info,
			errorInfo: err,
			vm: vm,
			info: info,
		});
	}
	console.error(err);
};
